import Loader from '@anm/components/Loader';
import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';

import LimitRow from './LimitRow';
import LimitsFooter from './LimitsFooter';
import Wrapper from './Wrapper';
import { UserLimitsProps } from './types';

const UserLimits: FC<UserLimitsProps> = ({
  data,
  isPending,
  planName,
  canUpgrade,
  thisMonthCharge,
  perMonthCharge
}) => {
  const isFooter = !!thisMonthCharge || !!perMonthCharge || canUpgrade;

  if (isPending) {
    return (
      <div>
        <Loader size="large" color="blue" />
      </div>
    );
  }

  return (
    <div>
      <TitleBlock title="Subscription limits" size="medium" level={2} />
      <Wrapper>
        {data.map((l, index) => (
          <LimitRow key={l.name} {...l} planName={planName} isMonthLimit={index < 2} />
        ))}
        {isFooter && <LimitsFooter {...{ thisMonthCharge, perMonthCharge }} />}
      </Wrapper>
    </div>
  );
};

export default UserLimits;
